import { useSyncExternalStore, useCallback } from 'react';

export const useMediaQuery = (query: string): boolean => {
  
  const subscribe = useCallback(
    (callback: () => void) => {
      const matchMedia = globalThis.matchMedia(query);

      matchMedia.addEventListener('change', callback);

      return () => {
        matchMedia.removeEventListener('change', callback);
      };
    },
    [query]
  );

  const getSnapshot = () => {
    return globalThis.matchMedia(query).matches;
  };

  const getServerSnapshot = () => {
    return false;
  };

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}